import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CreditCard, Share2, Gift, Ticket } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function ReferEarnSection() {
  const [program, setProgram] = useState(null);

  useEffect(() => {
    api.get("/referral/program")
      .then(({ data }) => { if (data.enabled && data.discount_inr > 0) setProgram(data); })
      .catch(() => {});
  }, []);

  if (!program) return null;

  const steps = [
    { icon: CreditCard, title: "Apply & Pay", text: "Complete any application. Your personal referral link appears on your tracking page right after payment." },
    { icon: Share2, title: "Share Your Link", text: `Send it to friends on WhatsApp — they instantly get ₹${Number(program.discount_inr).toLocaleString("en-IN")} off their first application.` },
    { icon: Gift, title: "Earn Coupons", text: `Every time a friend pays, you receive a ₹${Number(program.reward_inr).toLocaleString("en-IN")} coupon on WhatsApp to use on your next application.` },
  ];

  return (
    <section data-testid="refer-earn-section" className="py-16 sm:py-20 bg-[#1A1A1A]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="mb-10">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[var(--brand-primary)] mb-2">Referral Program</p>
          <h2 className="font-heading font-bold text-lg text-white">
            Refer friends. Earn ₹{Number(program.reward_inr).toLocaleString("en-IN")} every time they pay.
          </h2>
        </div>
        <div className="grid sm:grid-cols-3 gap-5 mb-10">
          {steps.map((s, i) => (
            <div key={s.title} data-testid={`refer-earn-step-${i + 1}`} className="rounded-lg border border-white/10 bg-white/5 p-6">
              <div className="flex items-center gap-3 mb-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[color-mix(in_oklab,var(--brand-primary),transparent_75%)]">
                  <s.icon size={18} className="text-[var(--brand-primary)]" />
                </span>
                <span className="text-[11px] font-bold text-white/40">STEP {i + 1}</span>
              </div>
              <p className="font-heading font-bold text-white text-base mb-1.5">{s.title}</p>
              <p className="text-[13px] leading-relaxed text-white/60">{s.text}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap gap-3">
          <Link to="/track">
            <Button data-testid="refer-earn-get-link-btn" className="bg-[var(--brand-primary)] hover:bg-[#9E855A] text-white h-11 px-6">
              <Share2 size={15} className="mr-2" /> Get My Referral Link
            </Button>
          </Link>
          <Link to="/my-coupons">
            <Button data-testid="refer-earn-my-coupons-btn" variant="outline" className="border-white/25 bg-transparent text-white hover:bg-white/10 hover:text-white h-11 px-6">
              <Ticket size={15} className="mr-2" /> View My Coupons
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
